module.exports = __webpack_public_path__ + "img/logo-purple.59bf00ec.png";